export default {
  namespaced: true,

  state: {
    penalties: [],
    loading: true
  },
  actions: {
    retrieve(context, id) {
      context.commit('clearRecord');
      context.commit('loading');

      window.Ajax.get(`/recharges/${id}`)
        .then(response => {
          context.dispatch('setRecharge', response.data);
          context.commit('loaded');
        })
        .catch(error => {
          window.toastify.error(
            'Sorry, there was a problem loading the recharge'
          );
        });
    },
    setRecharge(context, recharge) {
      context.commit('setPenalties', recharge.penalties || []);
    }
  },
  mutations: {
    setPenalties(state, penalties) {
      state.penalties = penalties;
    },
    addPenalty(state, penalty) {
      state.penalties.push(penalty);
    },
    removePenalty(state, identifier) {
      let index = state.penalties.findIndex(item => {
        return identifier === item.identifier;
      });

      state.penalties.splice(index, 1);
    },
    removePenalties(state) {
      state.penalties = [];
    },
    loading(state) {
      state.loading = true;
    },

    loaded(state) {
      state.loading = false;
    },
    clearRecord(state) {
      state.penalties = [];
    }
  },
  getters: {
    penalties(state) {
      return state.penalties;
    },
    loading(state) {
      return state.loading;
    }
  }
};
